var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupabase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_3680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8297 23.4266C13.2138 24.1912 12.0032 23.7664 11.9819 22.7894L11.7695 8.51685H21.3695C23.1111 8.51685 24.0881 10.5133 23.0049 11.8726L13.8297 23.4266Z",
    fill: "url(#paint0_linear_108_3680)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8297 23.4266C13.2138 24.1912 12.0032 23.7664 11.9819 22.7894L11.7695 8.51685H21.3695C23.1111 8.51685 24.0881 10.5133 23.0049 11.8726L13.8297 23.4266Z",
    fill: "url(#paint1_linear_108_3680)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92208 0.445973C10.538 -0.318628 11.7699 0.0849115 11.7699 1.0619L11.8761 15.3557H2.38225C0.640662 15.3557 -0.31509 13.338 0.768096 11.9787L9.92208 0.445973Z",
    fill: "#3ECF8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_3680",
    x1: 11.764,
    y1: 11.6759,
    x2: 20.2998,
    y2: 15.2559
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#249361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_108_3680",
    x1: 7.97961,
    y1: 6.49447,
    x2: 11.8724,
    y2: 13.8225
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_3680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupabase);
export default __webpack_public_path__ + "static/media/supabase.e4609c86d6eaad52725b6a251584b571.svg";
export { ForwardRef as ReactComponent };